import styled from 'styled-components';
import { playFontIcon } from '../../typography/helpers';
import { iconShowMore } from '../../design-tokens';
import { device } from '../../../ui-components/breakpoints';

export const StyledExpandButton = styled.div`
    margin-bottom: 40px;
    width: 100%;
    text-align: center;

    @media ${device.GteSmall} {
        margin-bottom: 20px;
    }
`;

export const StyledExpandButtonIcon = styled.span`
    &:before {
        ${playFontIcon(1.3, iconShowMore)}
    }
`;
